import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.34376 3.17475L8.42226 3.24408L11.9997 6.82083L15.5771 3.24408C15.8775 2.94367 16.3502 2.92057 16.6771 3.17475L16.7556 3.24408C17.056 3.54448 17.0791 4.01717 16.8249 4.34408L16.7556 4.42259L14.0113 7.16667H18.6663C19.9977 7.16667 21.0861 8.20743 21.1621 9.51977L21.1663 9.66667V18.8333C21.1663 20.214 20.0471 21.3333 18.6663 21.3333H5.33301C3.9523 21.3333 2.83301 20.214 2.83301 18.8333V9.66667C2.83301 8.28595 3.9523 7.16667 5.33301 7.16667H9.98717L7.24375 4.42259C6.91831 4.09715 6.91831 3.56951 7.24375 3.24408C7.54416 2.94367 8.01685 2.92057 8.34376 3.17475ZM18.6663 8.83333H5.33301C4.87277 8.83333 4.49967 9.20643 4.49967 9.66667V18.8333C4.49967 19.2936 4.87277 19.6667 5.33301 19.6667H18.6663C19.1266 19.6667 19.4997 19.2936 19.4997 18.8333V9.66667C19.4997 9.20643 19.1266 8.83333 18.6663 8.83333Z"
        fill="#191919"
      />
    </Svg>
  );
};

export default Icon;
